import React from 'react'
import '../../Styles/AdditionalPages/Admission.css'

export default function Admission() {
  return (
    <div className='admission'>
        Work under process
    </div>
  )
}
